import { render, staticRenderFns } from "./OrganisationSubGroupList.vue?vue&type=template&id=0bea2331&"
import script from "./OrganisationSubGroupList.vue?vue&type=script&lang=js&"
export * from "./OrganisationSubGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports